import {
  put,
  takeEvery,
  call
} from 'redux-saga/effects';

import * as actions from '../../actions';
import * as actionTypes from '../../actionTypes/ActionTypes';
import VoucherServices from '../../../services/voucherServices';

export default function* getVoucherSuggestInfoSaga() {
  yield takeEvery(actionTypes.VOUCHER.GET_VOUCHER_SUGGEST_INFO, getVoucherSuggestInfo);
}

export function* getVoucherSuggestInfo(action) {
  try {
    const response = yield call(VoucherServices.getVoucherSuggestInfo, action.payload);
    if (response.success) {
      yield put(actions.getVoucherSuggestInfoSuccess(response.data));
    } else {
      yield put(actions.getVoucherSuggestInfoFail(response.data));
    }
  } catch (error) {
    yield put(actions.getVoucherSuggestInfoFail(error));
  }
}
